import PropTypes from 'prop-types';
import React from 'react';
import FilterCheckboxes from '../FilterCheckboxes';

/**
 *  Filter By Color renders a group of checkbox elements with color swatch element and
 *  custom styling
 *
 *
 */
function FilterByColor(props) {
  const getFilterOptions = formattedOptions => formattedOptions && formattedOptions.map(option => ({
    ...option,
    label: option.label,
    colorValue: option.value
  }));
  return /*#__PURE__*/React.createElement(FilterCheckboxes, Object.assign({
    customFilterOptions: getFilterOptions,
    className: "visual-checkboxes"
  }, props));
}
export default FilterByColor;